import Image from 'next/image';
import styled from 'styled-components';
import TaskeenLogo from '../../../public/assets/images/common/taskeen-logo.svg';
import { useTranslation } from 'next-i18next';

const FulfilledByTaskeen = () => {
  const { t } = useTranslation('entity');
  return (
    <Container>
      <span className="fulfilled-by" itemProp="text">
        {t('fulfilled_by')}
      </span>
      <Image
        src={TaskeenLogo}
        alt="Taskeen Logo"
        width={92}
        height={34}
        itemProp="logo"
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 0 !important; // To escape a style applied div:not(#breadcrumbs): {margin-top: 32px}
  margin: 16px 0;

  .fulfilled-by {
    color: #4b535f;
    font-size: ${props => props.theme.font.sizes.s};
    font-family: materialRegular;
    margin-top: 8px;

    @media screen and (max-width: ${props =>
        props.theme.breakPoints.mobile.max}) {
      font-size: 10px;
    }
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    margin: 8px 0;
  }
`;

export default FulfilledByTaskeen;
